/**
 * Implementation of Dashboard Component accessible at "/dashboard"
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { useState } from "react";
import MonitorMap from "../../components/MonitorMap";
import { HiEye } from "react-icons/hi";
import { IoAlertCircle } from "react-icons/io5";
import AllMonitors from "../../components/AllMonitors";
import {useQuery} from "react-query";
import {getMonitors} from "../../api/requests";
import { When} from "react-if";
import CreateSSLMonitor from "../../components/CreateMonitor/CreateSSLMonitor";
import MainSatus from "../../components/MainStatus";
import { MonitorsResponse } from "../../api/responses";

export default function Dashboard() {

  const { data: monitors, isLoading: isMonitorsLoading, error: monitorsError } = useQuery<MonitorsResponse[]>('monitors',()=>getMonitors());

  return (
    <div>
      <MainSatus 
        monitorsLoading={isMonitorsLoading}
        monitors={monitors as MonitorsResponse[]}
      />

      {/* <div className="flex">
        <div className="bg-white rounded-xl shadow p-5 mb-5 w-2/3">
          <h1 className="text-lg font-semibold">Monitoring Map</h1>
          <MonitorMap />
        </div>

        <div className="flex-1 bg-white rounded-xl shadow p-5 ml-5 mb-5">
          <h1 className="text-lg font-semibold mb-3">Recent Events</h1>

          <div className="divide-y">
            <div className="flex py-3 items-center hover:bg-gray-100">
              <div className="mr-4 flex justify-center items-center rounded-lg bg-red-500 bg-opacity-10 w-10 h-10">
                <IoAlertCircle size={24} className="text-red-500" />
              </div>
              <div className="flex-1">
                <p className="text-primary">
                  Instatweet is alerting for 5 minutes.
                </p>
                <p className="text-gray-400 text-sm">2 minutes ago</p>
              </div>
            </div>

            <div className="flex py-4 hover:bg-gray-100">
              <div className="mr-4 flex justify-center items-center rounded-lg bg-green-500 bg-opacity-10 w-10 h-10">
                <HiEye size={24} className="text-green-500" />
              </div>
              <div className="flex-1">
                <p className="text-primary">
                  Instatweet is being monitored now.
                </p>
                <p className="text-gray-400 text-sm">Yesterday at 12:32 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="flex mb-5">
        <div className="bg-white rounded-xl shadow p-5 mb-5 flex-1">
          <div className="flex justify-between items-center">
          <h1 className="text-lg mb-3 font-semibold">All Monitors { monitors?.length ? `(${monitors?.length})`:'(-)' }</h1>
          <div className="mr-4"><CreateSSLMonitor /></div>
          
          </div>
          <div className="mt-4">
          <When condition={isMonitorsLoading}>
            <h1 className="text-lg mb-3 font-semibold">Loading</h1>
          </When>
          <When condition={!isMonitorsLoading && monitors?.length}><AllMonitors data={monitors as MonitorsResponse[]} /></When>
          </div>
        </div>
      </div>
    </div>
  );
}
